import { render } from "./ProfileWorkerPage.vue?vue&type=template&id=6245bc46&ts=true"
import script from "./ProfileWorkerPage.vue?vue&type=script&lang=ts"
export * from "./ProfileWorkerPage.vue?vue&type=script&lang=ts"

import "./ProfileWorkerPage.vue?vue&type=style&index=0&id=6245bc46&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__